(function($){

// **************** ADDITIONAL FUNCTIONS **************** //

var getCustomerMeta = function(customer) {
  $.ajax({
    type: "GET",
    url: 'https://ggi.company/ggi.host/customers/customers.php?ids=' + customer,
    data: '',
    dataType: 'json',
    async: true,
    success: function(response) {
		console.log(response);
    },
  })
	console.log('meta');
}

var addToWishlist = function(customer, product, wrapper, remove = false) {  
  $.ajax({
    type: "GET",
    url: 'https://ggi.company/ggi.host/customers/add_meta.php?id=' + customer + '&prod=' + product,
    dataType: 'html',
    async: true,
    beforeSend: function() {
      wrapper.children('.disable-overlay').addClass('active');
      wrapper.children('*').css('opacity', '0.15');
    },
    success: function(response) {
      if(response == 'added') {
      	wrapper.find('span.wishlist').addClass('remove-item').removeClass('add-item');
        wrapper.find('span.remove').removeClass('hidden');
        wrapper.find('span.add').addClass('hidden');
      }
      if(response == 'removed') {
      	wrapper.find('span.wishlist').removeClass('remove-item').addClass('add-item');
        wrapper.find('span.remove').addClass('hidden');
        wrapper.find('span.add').removeClass('hidden');
      }
      
      wrapper.children('.disable-overlay').removeClass('active');
      wrapper.children('*').css('opacity', '1');
      
      if(remove == 1) {
      	wrapper.parents('.product-row').remove();
      }
      
      if($('.wishlist-page .product-row').length == 0) {
      	$('.no-orders.hidden-imp').removeClass('hidden-imp');
      }
     
    },
    error: function(response) {
      $('.disable-overlay').removeClass('active');
    }
  })
}



//ajax pages for customer
var account_orders_page = function() {
  $.ajax({
    type: "GET",
    url: '/pages/custom-customer-orders-page',
    data: '',
    dataType: 'html',
    async: true,
    cache: false,
    success: function(response) {
      $('.top-block .title.h1-style').hide();
      $('.top-block .title.h1-style.dynamic').show().text('My Orders');
      $('.main-block').hide();
      var $result = $(response).find('.ajax-response');
      $('.ajax-dynamic').empty().append($result);
      window.scrollTo(0, 0);
    },
  })
}

var account_single_order_page = function(order_id) {
  var $result = '';
  $.ajax({
    type: "GET",
    url: '/pages/custom-customer-single-order-page?order=' + order_id,
    dataType: 'html',
    async: true,
    cache: false,
    success: function(response) {
      $('.top-block .title.h1-style').hide();
      $('.top-block .title.h1-style.dynamic').show().text('Order #' + order_id);
      $('.main-block').hide();
      var $result = $(response).find('.ajax-response');
      $('.ajax-dynamic').empty().append($result);
      window.scrollTo(0, 0);
    },
  })
}

var account_info_page = function() {
  var $result = '';
  $.ajax({
    type: "GET",
    url: '/pages/custom-customer-my-info',
    dataType: 'html',
    async: true,
    cache: false,
    success: function(response) { 
      $('.top-block .title.h1-style').hide();
      $('.top-block .title.h1-style.dynamic').show().text('My Info');
      $('.main-block').hide();
      var $result = $(response).find('.ajax-response');
      $('.ajax-dynamic').empty().append($result);
      window.scrollTo(0, 0);
    },
  })
}

var account_recently_viewed = function() {
  var $result = '';
  $.ajax({
    type: "GET",
    url: '/pages/custom-customer-recently-viewed',
    dataType: 'html',
    async: true,
    cache: false,
    success: function(response) {
      $('.top-block .title.h1-style').hide();
      $('.top-block .title.h1-style.dynamic').show().text('My Recently Viewed');
      $('.main-block').hide();
      var $result = $(response).find('.ajax-response');
      $('.ajax-dynamic').empty().append($result);
      window.scrollTo(0, 0);
    },
  })
}

var account_wishlist_page = function() {
  var $result = '';
  $.ajax({
    type: "GET",
    url: '/pages/custom-customer-wishlist-page',
    dataType: 'html',
    async: true,
    cache: false,
    success: function(response) {
      $('.top-block .title.h1-style').hide();
      $('.top-block .title.h1-style.dynamic').show().text('My Wishlist');
      $('.main-block').hide();
      var $result = $(response).find('.ajax-response');
      $('.ajax-dynamic').empty().append($result);
      window.scrollTo(0, 0);
    },
  })
}

var account_default_page = function() {
  var $result = '';
  $.ajax({
    type: "GET",
    url: '/pages/custom-customer-my-account',
    dataType: 'html',
    async: true,
    cache: false,
    success: function(response) {
      $('.top-block .title.h1-style').show();
      $('.top-block .title.h1-style.dynamic').hide();
      $('.main-block').hide();
      var $result = $(response).find('.ajax-response');
      $('.ajax-dynamic').empty().append($result);
      window.scrollTo(0, 0);
    },
  })

}



var ajax_register_submit = function(e) {
  e.preventDefault();

  var current_page = window.location.href;
      current_page = current_page.split('#')[0];

  var form = $(this);

  var first_name = form.find('#ajax-register-name').val();
  var last_name = form.find('#ajax-register-lastname').val();
  var email = form.find('#ajax-register-email').val();
  var password = form.find('#ajax-register-password').val();
  
  var redirect = form.find('input[name="redirect"]').val();
  
  var submit = form.find('button[type="submit"]');
  var alerts = form.find('.form-alerts');

  var data = {
      'customer[first_name]': first_name,
      'customer[last_name]': last_name,
      'customer[email]': email,
      'customer[password]': password,
      form_type: 'create_customer',
      utf8: '✓'
  };
  
  submit.attr('disabled', 'disabled');

  $.ajax({
      type: "POST",
      url: '/account',
      data: data,
      dataType: 'html',
      async: true,
      success: function(response) {
          var failed = response.indexOf('note form-error'); // true
          alerts.empty();
          if(failed > 0) {
            var $result = $(response).find('.note.form-error');
            alerts.append($result).show();
            submit.attr('disabled', false);
          }
          else {
            alerts.append('<p>Success!</p>').show();
            window.location.href = current_page;
            submit.attr('disabled', false);
          }
      },
  })
  return false;
}




var ajax_login_submit = function(e) {
	e.preventDefault();
  
    var current_page = window.location.href;
        current_page = current_page.split('#')[0];
  
  	var form = $(this);

    var email = form.find('#ajax-login-email').val();
  	var password = form.find('#ajax-login-password').val();
  	var submit = form.find('button[type="submit"]');
  	var alerts = form.find('.form-alerts');
 
    var redirect = form.find('input[name="redirect"]').val();

  var data = {
        'customer[email]': email,
        'customer[password]': password,
        form_type: 'customer_login',
        utf8: '✓'
    };
    submit.attr('disabled', 'disabled');

    $.ajax({
        type: "POST",
        url: '/account/login',
        data: data,
        dataType: 'html',
        async: true,
        success: function(response) {
            var failed = response.indexOf('note form-error'); // true
          	alerts.empty();
            if(failed > 0) {
                var $result = $(response).find('.note.form-error');
                alerts.append($result).show();
                submit.attr('disabled', false);
            }
            else {
              if(redirect.length < 1) {
                window.location.href = current_page;
              }
              else {
                window.location.href = redirect;
              }
              submit.attr('disabled', false);
            }
//           console.log(current_page);
        },
    })
    return false;
}





var ajax_recover_submit = function(e) {
	e.preventDefault();
  
    var form = $(this);

    var email = form.find('#ajax-login-recover').val();
    var submit = form.find('button[type="submit"]');
  	var alerts = form.find('.form-alerts');
  
    var data = {
      'email': email,
      form_type: 'recover_customer_password',
      utf8: '✓'
    };
  
    submit.attr('disabled', 'disabled');
  
    $.ajax({
      type: "POST",
      url: '/account/recover',
      data: data,
      dataType: 'html',
      async: true,
      success: function(response) {
        var failed = response.indexOf('note form-error'); // true
        var successed = response.indexOf('note form-success');
        alerts.empty();
        if(failed > 0) {
          var $result = $(response).find('.note.form-error').last();
          alerts.append($result).show();
          submit.attr('disabled', false);
        }
        else {
          var $result = $(response).find('.note.form-success').last();
          alerts.append($result.show()).show();
          submit.attr('disabled', false);
        }
      },
    })
}
     


var show_login_popup = function(redirect) {
  $('#loginModal').modal('show');
  $('.ajax-login-register-modal .register-row').addClass('d-none');
  $('.ajax-login-register-modal .login-row').removeClass('d-none');
  $('.ajax-login-register-modal .login-row').find('input[name="redirect"]').val(redirect);
  $('.ajax-login-register-modal .register-row').find('input[name="redirect"]').val(redirect);
  if($('html').hasClass('show-nav')) {
    $('button.menu-toggle').click();
  }
}

var show_register_popup = function() {
  $('#loginModal').modal('show');
  $('.ajax-login-register-modal .login-row').addClass('d-none');
  $('.ajax-login-register-modal .register-row').removeClass('d-none');
  if($('html').hasClass('show-nav')) {
    $('button.menu-toggle').click();
  }
}



var queryConvert = function(str){
    var queryStr = window.location.search,
      queryArr = queryStr.replace('?','').split('&'),
      queryParams = [];

    for (var q = 0, qArrLength = queryArr.length; q < qArrLength; q++) {
        var qArr = queryArr[q].split('=');
        queryParams[qArr[0]] = qArr[1];
    }

    return queryParams;
}


// **************** END ADDITIONAL FUNCTIONS **************** //









$(document).ready(function() {
  
  // Ajax login, register and logout
  
  $('form.ajax-login').on('submit', ajax_login_submit);
  
  $('form.ajax-register').on('submit', ajax_register_submit); 
  
  $('form.ajax-recover').on('submit', ajax_recover_submit);
  
  $('.ajax-login-register-modal').on('click', '.toggler', function(){
  	var show = $(this).data('show');
    var hide = $(this).data('hide');
    
    $('.ajax-login-register-modal').find($('.' + show)).removeClass('d-none');
    $('.ajax-login-register-modal').find($('.' + hide)).addClass('d-none');
  })
  
  $('button.login-account').on('click', function(){
    $('.ajax-login-register-modal .register-row').addClass('d-none');
  	$('.ajax-login-register-modal .login-row').removeClass('d-none');
  })
  
  $('button.create-account').on('click', function(){
    $('.ajax-login-register-modal .login-row').addClass('d-none');
  	$('.ajax-login-register-modal .register-row').removeClass('d-none');
  })
  
  
  $('body').on("click", 'a[href="/account"], a[href="/account/login"]', function(e) {
    if(!$('body').hasClass('customer-logged-in')) {
      e.preventDefault();
      show_login_popup();
    }
  })
  
  $('body').on("click", 'a[href="/account/register"]', function(e) {
    if(!$('body').hasClass('customer-logged-in')) {
      e.preventDefault();
      show_register_popup();
    }
  })
  
  $('body').on('click', '.recover-open', function(){
  	$('.ajax-recover').removeClass('hidden');
    $('.ajax-login').addClass('hidden');
  })
  
  $('body').on('click', '.recover-close', function(){
  	$('.ajax-recover').addClass('hidden');
    $('.ajax-login').removeClass('hidden');
  })
  
  
  $('body').on("click", 'a[href^="/account/logout"]', function() {
    var current_page = window.location.href;
    if(current_page.indexOf('account') > -1 ) {
      current_page = 'https://www.greatgiftitems.com';
    }
    $.ajax( 
      $(this).attr('href') 
    ).done(function() {
      current_page = current_page.split('#')[0];
      window.location.href = current_page;
    });
    return false;
  });
  
  // END Ajax login and logout
  
  $('body').on('click', '.recently-viewed-page .recent-products-page .wishlist-action .btn', function(e){
    e.preventDefault();
    var wrapper = $(this).parent($('wishlist-action'));
    var prod_id = $(this).data('prod-id');
    var user_id = $(this).data('user-id');
    addToWishlist(user_id, prod_id, wrapper);
  }) 
  
  $('body').on('click', '.wishlist-page .wishlist-action .btn', function(e){
    e.preventDefault();
    var wrapper = $(this).parent($('wishlist-action'));
    var prod_id = $(this).data('prod-id');
    var user_id = $(this).data('user-id');
    addToWishlist(user_id, prod_id, wrapper, 1);
  })
  
  $('body').on('click', '.product-grid-item .wishlist-wrapper', function(e){
    e.preventDefault();
    var prod_id = $(this).data('prod-id');
    var user_id = $(this).data('user-id');
    var wrapper = $(this);
    addToWishlist(user_id, prod_id, wrapper);
  })
  
  $('body').on('click', '.my-account-page .recent-products-page .wishlist-action .btn', function(e){
    e.preventDefault();
    var prod_id = $(this).data('prod-id'); 
    var user_id = $(this).data('user-id');
    var wrapper = $(this).parent($('wishlist-action'));
    addToWishlist(user_id, prod_id, wrapper);
  })
  
  
  $('body').on('click', '.product-wrapper .wishlist-wrapper', function(e){
    e.preventDefault();
    var prod_id = $(this).data('prod-id');
    var user_id = $(this).data('user-id');
    var wrapper = $(this);
    addToWishlist(user_id, prod_id, wrapper);
  })
  
  $('body').on('click', '.wishlist.not-logged', function(){
  	show_login_popup();
  })
  
  
  
  if($('.template-index')) {
    var check_query_string = location.search;
    if(check_query_string) {
    	var params = queryConvert(check_query_string);
      if(params['action'] == 'login') {
        show_login_popup('/' + params['redirect']);
      }
    }
  }
  
  
  
  
  
  
  
  
  
  
//   $('.account-page-wrapper').on('click', '.ajax-action', function(e){
//   	e.preventDefault();
//     var fn = $(this).data('fn');
//     var order_id = $(this).data('id');
//     var url = $(this).attr('href');
//     window.history.pushState("", "", url);
//     window[fn](order_id);
//   })
  
  
  $('.account-page-wrapper').on('click', '.ajax-print-order', function() {
    var html = $(".account-page-wrapper .single-order").html();
    var related = '';
    if($('.related-products')) {
      related = related  + '<div class="related"><h2>We Also Recommend</h2>';
      $('.related-products .active').each(function(){
      	related = related + $(this).html() 
      })
      related = related + '</div>';
    }
   	var mywindow = window.open('', 'PRINT', 'width=1000,height=800');
    mywindow.document.write('<html><head><title></title>');
    mywindow.document.write('</head><body class="printer"><div class="account-page-wrapper">');
    mywindow.document.write(html);
    mywindow.document.write(related);
    mywindow.document.write('</div></body></html>');
    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/
    setTimeout(function() {
      mywindow.print();
      mywindow.close();
    }, 1000)
     
    return false;
  })
  
  
  // actions depends on url checking  
  var current_url = window.location.href;
  if(current_url.indexOf('/account') > -1) {
    
    if($('body').hasClass('customer-logged-in')) {
      if(current_url.indexOf('/account#orders') > -1 && current_url.indexOf('/account#orders/order') < 0) {
  	  	account_orders_page();
      }
      else if(current_url.indexOf('/account#orders/order') > -1) {
        var order_id = current_url.split('orders/order/').pop();
        account_single_order_page(order_id);
      }
      else if(current_url.indexOf('/account#info') > -1) {
      	account_info_page();
        console.log('info');
      }
      else if(current_url.indexOf('/account#recent') > -1) {
      	account_recently_viewed();
      }
      else if(current_url.indexOf('/account#wishlist') > -1) {
      	account_wishlist_page();
      }
      else {
        account_default_page();
      }
    }
  }
  
  
  
  
//   	if($(window).width() < 769) {   
//       $("html").on("swipeleft",function(){
//         if($('html').hasClass('show-nav')) {
//           $('html').removeClass('show-nav');
//         }
//       });
      
//       $("html").on("swiperight",function(){
//        	if($('.account-block.mobile-view').hasClass('shown')) {
//         	$('.account-block.mobile-view').removeClass('shown');
//           	$('body').removeClass('nooverflow');
//     		$('body').removeClass('shadow');
//         }
//       })
      
//       $('html').on('tap', function(e){
//         if($(e.target).hasClass('fake-bg')) {
//         	$('.account-block.mobile-view').removeClass('shown');
//           	$('body').removeClass('nooverflow');
//     		$('body').removeClass('shadow');
//           $('html').removeClass('show-nav');
//         }
//       })
      
//       $('button#toggleFilters').text('Filter');
//       $('button#toggleFilters').show();
      
//       $('aside.sidebar').insertAfter('.collection-items .section-header');
      
//       $('.star-rating-wrapper.mobile-view').appendTo('.product-meta');
//       $('#mobileNavBar .glass-wrap').on('click', function(e){
//           e.preventDefault();
//           $('header.site-header').toggleClass('search-visible');
//       })
//       if($('.template-cart')) {
//       	$('.quantity-field').appendTo('.mobile-view .quantity-input');
//       }
      
//       if($('.template-collection')){
//         $('#collectionFilters').insertAfter($('header.section-header'));
//       }
      
//       if($('.template-product')) {
//       	$('.hulkapps-volumes-wrapper').insertAfter($('.quant-wrap'));
//       }
      
//     } 
  
  
  
//   $(window).resize(function(){
//   	if($(window).width() < 769) {    
//       $("html").on("swipeleft",function(){
//         if($('html').hasClass('show-nav')) {
//           $('html').removeClass('show-nav');
//         }
//       });
//       $('button#toggleFilters').text('Filter');
//       $('button#toggleFilters').show();
//       $('aside.sidebar').insertAfter('.collection-items .section-header');  
//       if($('.product-meta .star-rating-wrapper.mobile-view').length < 1) {
//       	$('.star-rating-wrapper.mobile-view').appendTo('.product-meta');
//       }
//       $('#mobileNavBar .glass-wrap').on('click', function(e){
//           e.preventDefault();
//           $('header.site-header').toggleClass('search-visible');
//       })
//       $('.selector-wrapper').each(function(){
//           $(this).css('display', 'flex');
//       })
//       if($('.template-cart')) {
//       	$('.quantity-field').appendTo('.mobile-view .quantity-input');
//       }
      
//       if($('.template-collection')){
//         $('#collectionFilters').insertAfter($('header.section-header'));
//       }
//     } else {
//       $('button#toggleFilters').hide();
//       $('aside.sidebar').prependTo('.grid.grid-border');
//       $('.selector-wrapper').each(function(){
//         if($(this).find('label').text().indexOf('Bulk') < 0) {
//             $(this).show();
//           	$(this).css('display', 'block');
//         } else {
//             $('.bulk-disc-switch').show();
//             $bulk_field = $(this);
//           $('.quant-wrap').hide();
//           $bulk_field.show();
//         }
//       })
//       if($('.template-cart')) {
//       	$('.quantity-field').appendTo('.desktop-view .quantity-input');
//       }
      
//       if($('.template-collection')){
//         $('#collectionFilters').insertBefore($('.collection-items'));
//       }
//     }
//     $('.selector-wrapper').each(function(){
//       if($(this).find('label').text() == 'Style') {
//           $(this).hide();
//       }
//     })
    
//     if($('.my-info-page').length > 0) {
//       var window_height = $(window).height();
//       var visible_form = $('.address-wrapper form .inner-wrapper:visible, #address_form_new form .inner-wrapper:visible, .ajax-account-edit form .inner-wrapper:visible');
//       var form_height = visible_form.height() + 10;
//       var target_height = window_height - 10;
//     }
  
//     if($('.template-product')) {
//       $('.hulkapps-volumes-wrapper').insertAfter($('.quant-wrap'));
//     }
//   })
  
  $('.selector-wrapper').each(function(){
    if($(this).find('label').text() == 'Style') {
    	$(this).hide();
    }
  })

})

$(document).ready(function() {
  
  $('.index-carousel').owlCarousel({
  	items: 5,
  	loop: true,
    dots: false,
    margin: 15,
    nav: true,
    responsiveClass:true,
    responsive:{
        0:{
            items:2,
          	loop: true
        },
        481:{
            items:3,
          	loop: true
        },
        769:{
            items:4,
            loop: true
        },
      	1061:{
            items:5,
            loop: false
        }
    }
  });
  
  
  $('.best-selling-carousel').owlCarousel({
    items: 5,
    loop: true,
    dots: false,
    margin: 15,
    nav: true,
    responsiveClass:true,
    responsive:{
        0:{
            items:2,
            loop: true
        },
        481:{
            items:3,
            loop: true
        },
        769:{
            items:4,
            loop: true
        },
        1061:{
            items:5,
            loop: false
        }
    }
  });
  
  

  
  
  
  
//     $('.grid-uniform.related-products').addClass('owl-carousel');

  
  //sets savings calculations
  
//   $('.selector-wrapper').each(function(){
//     if($(this).find('label').text().indexOf('Bulk') < 0) {
      	
//       	$(this).show();
      
//     } else {
//     	$('.bulk-disc-switch').show();
//      	$bulk_field = $(this);
//       $('.quant-wrap').hide();
//       $bulk_field.show();
//     }
//   })
  
//   $('.bulk-disc-switch input').change(function(){
//     if($(this).prop('checked')) {
//     	$bulk_field.show();
//       $('.quant-wrap').hide();
      
//       $('.bulk-disc-switch label').text("Remove Bulk Discount");
//     }
//     else {
//       $bulk_field.find('select').find('option').first().prop('selected',true).trigger('change');
//       $bulk_field.hide();
//       $('.quant-wrap').show();
//       $('.bulk-disc-switch label').text("Add Bulk Discount");
      
//     }
//   })
  
//   $('.template-index .owl-carousel').owlCarousel({
//   	items: 5,
//   	loop: true,
//     responsiveClass:true,
//     responsive:{
//         0:{
//             items:2,
//           	loop: true
//         },
//         481:{
//             items:3,
//           	loop: true
//         },
//         769:{
//             items:4,
//             loop: true
//         },
//       	1061:{
//             items:5,
//             loop: true
//         }
//     }
//   });
//   $(".related-products.owl-carousel").owlCarousel({
//        items: 5,
//        loop: true,
//        responsiveClass:true,
//        responsive:{
//         0:{
//             items:2,
//           	loop: true
//         },
//         520:{
//             items:3,
//           	loop: true
//         },
//         670:{
//             items:4,
//           	loop: true
//         },
//         1060:{
//             items:5,
//             loop: true
//         }
//        }
//   });
  
//   $('#addToCartForm .selector-wrapper').each(function(){
//     if($(this).find('option').length < 2) { $(this).hide(); }
//   })
  
  
//   if($('.template-collection').length && $(window).width() > 2399 && $(window).width() < 3200) {
//   	var count_items = $('.items-block .grid-item').length;

//     while (count_items % 4) {
//       $('.items-block').append('<div class="grid-item large--one-quarter medium--one-third small--one-half placeholder"></div>');
//       count_items++;
//     }
//   }
  
//   if($('.template-collection').length && $(window).width() > 3199) {
//   	var count_items = $('.items-block .grid-item').length;

//     while (count_items % 5) {
//       $('.items-block').append('<div class="grid-item large--one-quarter medium--one-third small--one-half placeholder"></div>');
//       count_items++;
//     }
//   }
  
//   $('.var-img').on('click', function(){
//     $('.var-img').removeClass('active');
//   	$(this).toggleClass('active');
//   })
  
//   if($(window).width() > 768) {
    
//     $('.addtocart-wrapper').hover(
//       function() {
//         if($('#addToCart').hasClass('disabled')) {
//           $('.selector-wrapper select').each(function(){
//             if($(this).val() == '') {
//                 $(this).addClass('not-selected');
//             }
//           })
//           if($('input.quantity-selector').val().length < 1 || $('input.quantity-selector').val() == 0) {
//             $('input.quantity-selector').addClass('not-selected');
//           }
//         }

//       }, function() {
//         if($('#addToCart').hasClass('disabled')) {
//           $('.selector-wrapper select').removeClass('not-selected');
//           $('input.quantity-selector').removeClass('not-selected');
//         }
//       }
//     );
    
//     $('.grouped-addtocart-wrapper').hover(
//       function(){
// //         if($('#grouped-addToCart').hasClass('disabled')) {
//           $('.selector-group-wrapper select').addClass('not-selected');
// //         }
//       }, 
//       function(){
//         $('.selector-group-wrapper select').removeClass('not-selected');
//       }
//     )
//   }
  
//   $('.var-img').on('click', function(){
//   	var image = $(this).find('img').attr('src');
//     image = image.replace('_small.', '.').replace('_0x2.', '.');
//     $('#productPhotoImg').attr('src', image);
//     $('.zoomImg').attr('src', image);
//   })
  
//   $('.single-option-selector').on('change', function(){
//   	var value = $(this).val();
//     $('.var-img').each(function(){
//       if($(this).data('name') == value) {
//       	$(this).click();
//       }
//     })
//   })
  
//   if($('.description').length > 0) {
//     $('.description img').each(function(){
//       	var image = $(this);
//       	var src = $(this).attr('src');
//       if(src.indexOf('Shipping') > -1) {
//       	var new_src = src.substring(0, src.indexOf('?'));
//       	$(this).attr('src', new_src);
//       }
//     })
//   }
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
// login registed actions
//   var login_popup = function() {
//   	$('body').addClass('nooverflow');
//   	$('.popup-login').addClass('shown');
//     $('.for-form-error').empty().hide();
//   }
  
//   var register_popup = function() {
//   	$('body').addClass('nooverflow');
//   	$('.popup-register').addClass('shown');
//     $('.for-form-error').empty().hide();
//   }
  
//   $('.account-block.desktop-view').on('click', '.fake-link.login', function(){
//     return login_popup();
//   })
  
//   $('.account-block.desktop-view').on('click', '.fake-link.register', function(){
//     return register_popup();
//   })
  
//   $('.form-close').on('click', function() {
//   	$(this).parents($('.shown.to-close')).removeClass('shown');
//     $('body').removeClass('nooverflow');
//     $('body').removeClass('shadow');
//   })
  
//   $('.fake-link').on('click', function(e) { 
//   	e.preventDefault();
//   })
  
  
  
//   	$('.popup-login #customer_login input[type="submit"]').on('click', function(e) {
// 		e.preventDefault();
//      	$('.for-form-error').empty().hide();
//      	var current_page = window.location.href;
//       		current_page = current_page.split('#')[0];
      
//       	var submit = $(this);
//      	var email = $('#customer_login input[name="customer[email]"]').val();
//      	var password = $('#customer_login input[name="customer[password]"]').val();
//       	var redirect = $('#customer_login input[name="redirect-arg"]').val();
//      	var data = {
//       		'customer[email]': email,
//       		'customer[password]': password,
//       		form_type: 'customer_login',
//       		utf8: '✓'
//      	};
//     	submit.attr('disabled', 'disabled');
    
//         $.ajax({
//           	type: "POST",
//           	url: '/account/login',
//           	data: data,
//           	dataType: 'html',
//           	async: true,
//           	success: function(response) {
//             	var failed = response.indexOf('note form-error'); // true
//             	if(failed > 0) {
//                 	var $result = $(response).find('.note.form-error');
//                 	$('div.for-form-error').append($result).show();
//                   	submit.attr('disabled', false);
//             	}
//             	else {
//                   if(redirect.length < 1) {
//                 	window.location.href = current_page;
//                   }
//                   else {
//                   	window.location.href = redirect;
                  	
//                   }
//                   submit.attr('disabled', false);
//             	}
//           	},
//         })
//         return false;
//   	})
// End Ajax login and logout
    
// Ajax register
// 	$('.popup-register #create_customer input[type="submit"]').on('click', function(e) {
// 		e.preventDefault();
//      	$('.for-form-error').empty().hide();
//      	var current_page = window.location.href;
//       		current_page = current_page.split('#')[0];
      
//       	var submit = $(this);
      
//       	var first_name = $('#create_customer input[name="customer[first_name]"]').val();
//       	var last_name = $('#create_customer input[name="customer[last_name]"]').val();
//      	var email = $('#create_customer input[name="customer[email]"]').val();
//      	var password = $('#create_customer input[name="customer[password]"]').val();
//      	var data = {
//           	'customer[first_name]': first_name,
//           	'customer[last_name]': last_name,
//       		'customer[email]': email,
//       		'customer[password]': password,
//       		form_type: 'create_customer',
//       		utf8: '✓'
//      	};
//     	submit.attr('disabled', 'disabled');

//         $.ajax({
//           	type: "POST",
//           	url: '/account',
//           	data: data,
//           	dataType: 'html',
//           	async: true,
//           	success: function(response) {
//             	var failed = response.indexOf('note form-error'); // true
//             	if(failed > 0) {
//                   	var $result = $(response).find('.note.form-error');
//                 	$('div.for-form-error').append($result).show();
//                   	submit.attr('disabled', false);
//             	}
//             	else {
//                 	window.location.href = current_page;
//                   	submit.attr('disabled', false);
//             	}
//           	},
//         })
//         return false;
//   	})
// End Ajax register
    
 
    
//     var show_login_popup = function(arg) {
//    	  $('.popup-register').removeClass('shown');
//       $('.popup-login').addClass('shown');
//       $('.for-form-error').empty().hide();
//       $('input[name="redirect-arg"]').val(arg);
//     }
    
//      var show_register_popup = function() {
//    	  $('.popup-login').removeClass('shown');
//       $('.popup-register').addClass('shown');
//       $('.for-form-error').empty().hide();
//     }
  
//     $('.popup-register .desktop-view .to-login, .popup-register .div-left .desktop-view .to-login').on('click', function(e){
//       e.preventDefault();
//       return show_login_popup();
//     })

//     $('.popup-login .desktop-view .to-register').on('click', function(e){
//       e.preventDefault();
//       return show_register_popup();
//     })

//     if(!$('body').hasClass('customer-logged-in')) {
//       $('body').on('click', 'a[href^="/account"]', function(e){
//         e.preventDefault();
//         var arg = '';
//         if($(this).hasClass('order-status')) {
//         	arg = '/account#orders';
//         } 
//         return show_login_popup(arg);
//       })
//     }
  
//     if($(window).width() < 769) { 
//         $('.account-wrap.fake-link.not-logged').on('click', function(){
//           $('.popup-login').addClass('shown');
//           $('body').addClass('shadow');
//           $('body').addClass('nooverflow');
//         })

//         $('.account-wrap.fake-link.logged-in').on('click', function(){
//           $('.account-block.mobile-view').toggleClass('shown');
//           $('body').toggleClass('shadow');
//           $('body').toggleClass('nooverflow');

//         })

//         $('.to-register').on('click', function(e){
//           e.preventDefault();
//           $('.popup-login').removeClass('shown');
//           $('.popup-register').addClass('shown');
//         })

//         $('.to-login').on('click', function(e){
//           e.preventDefault();
//           $('.popup-login').addClass('shown');
//           $('.popup-register').removeClass('shown');
//         })
//     }
  
  
  
// setup cookie to check filters block on mobiles
function setCookie(name, value, options) {
  options = options || {};

  var expires = options.expires;

  if (typeof expires == "number" && expires) {
    var d = new Date();
    d.setTime(d.getTime() + expires * 1000);
    expires = options.expires = d;
  }
  if (expires && expires.toUTCString) {
    options.expires = expires.toUTCString();
  }

  value = encodeURIComponent(value);

  var updatedCookie = name + "=" + value;

  for (var propName in options) {
    updatedCookie += "; " + propName;
    var propValue = options[propName];
    if (propValue !== true) {
      updatedCookie += "=" + propValue;
    }
  }

  document.cookie = updatedCookie;
}
  
function getCookie(name) {
  var matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function deleteCookie(name) {
  setCookie(name, "", "")
}
  
  
  
  


  
  
  
  

//   $('.wishlist-wrapper').on('click', '.not-logged', function(e){
//     e.preventDefault();
//     login_popup();
//   }) 
  
  
  $('.mobile-nav .menu-icon, a[data-meganav-type="parent"]').on('click', function(e){
    if($(window).width() < 769) {
      e.preventDefault();
      $(this).siblings('.mobile-nav--button').click();
    }
  })
  
  
  
  
  
  
//   var inputs = $('.selector-wrapper');
//   inputs.each(function(){
//       var input = $(this);
//       var label = input.find('label').text();
//       var first_option = input.find('option').first();
//       if(label.toLowerCase() != 'style' && input.find('option').length > 1) {
//         input.css('display', 'flex');
//       }

//   })
  
  
  
//   var check_all_inputs = function() {
//   	var inputs = $('.selector-wrapper select, .quantity-wrapper input');
    
//     inputs.each(function(){
//       var input = $(this);
//       if(input.val() == null || !input.val().length) {
//         input.addClass('ggi-has-error');
//       }
//     })
//   }
  
//   var reset_all_inputs = function() {
//     var inputs = $('.selector-wrapper select, .quantity-wrapper input');
//     inputs.removeClass('ggi-has-error');
//   }
  
//   $('.add-to-cart-wrapper').hover(check_all_inputs, reset_all_inputs);
  
  
  
  
//   $('body').on('change', '.selector-wrapper select, .quantity-wrapper input', function(){
    
//     if($(this).siblings('label').text() == 'Color') {
//       var color_input = $(this);
//       var selected_color = color_input.val();
//       var eq = $('.selector-wrapper').index() - 1;
      
//       for(k in variantImages) {
//         if(variantImages[k]['option-' + eq] == selected_color) {
//         	var img_to_select = k;
//           	img_to_select = img_to_select.replace('.png', '').replace('.jpg', '');
//         }
//       }
      
//       $('.product-photo-thumb').each(function(){
//         if($(this).attr('href').indexOf(img_to_select) > -1) {
//         	$(this).click();
//         }
//       })
//     }

    
//     var inputs = $('.selector-wrapper select, .quantity-wrapper input');
//     var add_cart_btn = $('.btn--add-to-cart');
//     var isEmpty = 0;
        
    
//     inputs.each(function(){
//       var input = $(this);
//       if(input.val() == null || !input.val().length) {
//         isEmpty = 1;
//       }
//     })
    
//     if(isEmpty == 0) {
//       add_cart_btn.removeClass('btn-disabled');
//     }
//     else {
//       add_cart_btn.addClass('btn-disabled');	
//     }
    
//   })
  
  
  function rafAsync() {
      return new Promise(resolve => {
          requestAnimationFrame(resolve); //faster than set time out
      });
  }

  function checkElement(selector) {
      if (document.querySelector(selector) === null) {
          return rafAsync().then(() => checkElement(selector));
      } else {
          return Promise.resolve(true);
      }
  }
  
  checkElement('.selector-wrapper') 
  .then((element) => {
    
    var selectors = $('.selector-wrapper');
    
    selectors.each(function(selector){
      var label = $(this).find('label').text().toLowerCase();
      $(this).addClass(label);
    })

	
    var product = null;
	var options_wrapper = $('#custom-product-options');
    var optionsEnabled = ['color', 'size'];
    
    $('.selector-wrapper').each(function(){
      var option = $(this);
      var label = option.find('label').text();
      var select = option.find('select');
      var name = select.data('option');
      
      if(optionsEnabled.indexOf(label.toLowerCase()) != -1) {
        var div = document.createElement('div');
        div.setAttribute('class', 'custom-option-single ' + label.toLowerCase());
        div.setAttribute('data-option-name', name);
        div.setAttribute('id', 'custom-option-' + name);

        if(label.toLowerCase() == 'color') {
          div.innerHTML = '<label><b>' + label.toUpperCase() + '</b> - <span>' + select.val().toUpperCase() + '</span></label>';
        }
        else {
          div.innerHTML = '<label><b>' + label.toUpperCase() + '</b></label>';
        }
      
        document.getElementById('custom-product-options').appendChild(div);

        select.children('option').each(function(k){
          var sub_div = document.createElement('div');
          let option_text = $(this).text();
          let option_value = $(this).val();
          let is_selected = $(this).is(':selected');

          let option_classes = 'item';
          if(is_selected) {
            option_classes += ' active';
          }

          sub_div.setAttribute('data-option-val', option_value);
          sub_div.setAttribute('class', option_classes);

          if(label.toLowerCase() != 'color') {
            sub_div.innerHTML = '<div>' + option_text + '</div>';	
          }
          else {
            sub_div.innerHTML = '<div class="img"></div>';
          }

          document.getElementById('custom-option-' + name).appendChild(sub_div);
        })
      }
    })
    
    
    if(Object.entries(option_images).length > 0) {
      Object.keys(option_images).map(function(objectKey, index) {
        var value = option_images[objectKey];
        $('.custom-option-single.color div[data-option-val="' + objectKey + '"] div.img').css('background-image', 'url("' + value + '")');
      });
    }
    
    $('.custom-option-single').on('click', '.item', function(e){
      var option_to_change = $(this).parents('.custom-option-single').data('option-name');
      var option_val = $(this).data('option-val');
      $(this).addClass('active').siblings('.item').removeClass('active');
      $('.single-option-selector[data-option="' + option_to_change + '"]').val(option_val).change();
      $(this).siblings('label').find('span').text(option_val.toUpperCase());
    })

  });
  
  
  
  if($('.collection-custom-options-color').length > 0) {
    
    $('.collection-custom-options-color').each(function(item, elem){
      var product_url = $(this).data('url');
      var product = product_url + '.js';
      
      var this_elem = elem;
      
      var item_index = item;
      
      $.getJSON(product, function(data) {

        var variants = data.variants;
        
        data.options.forEach(function(element, index){
          if(element.name.toLowerCase() == "color") {
            
            var color_index = index;

            element.values.forEach(function(element, index) {
              
              var result = variants.filter(obj => {      
                if(obj.options[color_index] == element) {
                  return color_featured_img = obj.featured_image.src;
                }
              })
              
              var div = document.createElement('div');
              
              div.setAttribute('class', 'collection-custom-option-single-color');
              div.setAttribute('data-color', element);
              div.setAttribute('data-color-img', color_featured_img);
              
              var html = '<div class="pt-display-swatch">';
              html += '<ul>';
              html += '<div class="filter-active-color-' + element.toLowerCase().replace(' ', '-') + '">';
              html += '<div class="collection-name">';
              
              html += '<i class="check-icon"></i>';
              
              html += '</div></div></ul></div>';
              
              div.innerHTML = html;


              $(this_elem).addClass('enabled mb-2');
              $(this_elem).find('.inner-wrap').append(div);
            })
           
          }
        })

      });
    })
    
        
    $('.collection-custom-options-color').on('click', '.collection-custom-option-single-color', function(){
      var colorImage = $(this).data('color-img').replace('.png', '_360x.png').replace('.jpg', '_360x.jpg');
      var img = document.createElement('img');
      
      img.setAttribute('class', 'lazyload no-js product-grid-item-image');
      img.setAttribute('data-src', colorImage);
      img.setAttribute('data-widths', '[125, 180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]');
      img.setAttribute('data-aspectratio', '1.0');
      img.setAttribute('data-sizes', 'auto');
      
      $(this).parents('.product-grid-item').find('.product-grid-item-image').replaceWith(img);
    })
    
    
    $(window).resize(function(){
      $('.collection-custom-options-color').each(function(){
        var itemBlock = $(this).find('.inner-wrap');
        var itemOptions = $(this).find('.collection-custom-option-single-color');
        var getInnerWidth = 0;
        var getWidth = itemBlock.width();
        
        itemOptions.each(function(){
          getInnerWidth = getInnerWidth + $(this).outerWidth();
        })
      	
        if(getInnerWidth > getWidth) {
          $(this).addClass('show-chevrons');
        }
        else {
          $(this).removeClass('show-chevrons');
        }
      })
    })
    
    	
    $(window).load(function(){
      window.dispatchEvent(new Event('resize'));
    })
    
    $('.collection-custom-options-color').on('click', '.collection-custom-option-single-color', function(){
      $(this).parents('.collection-custom-options-color').find('.collection-custom-option-single-color').removeClass('active');
      $(this).addClass('active');
    })
    
    $('.product-grid-item').on('click', '.collection-custom-options-color.show-chevrons .options-nav', function(){
      
      var scrollBar = $(this).parents('.inner-wrap');
      var scrollbarWidth = scrollBar.width();
      var itemWidth = scrollBar.find('.collection-custom-option-single-color').outerWidth() + 2;
      var direction = $(this).data('scroll');
      
      switch(direction) {
        case 'scrollLeft': 
          scrollBar.animate({
//             scrollLeft: '-' + itemWidth + 'px'
            scrollLeft: '-=' + itemWidth
          }, 100);
        break;
          
        case 'scrollRight': 
          scrollBar.animate({
//             scrollLeft: itemWidth + 'px'
            scrollLeft: '+=' + itemWidth
          }, 100);
        break;
      }
    })
  }
  
  

  var myElement = document.body;
  var mc = new Hammer(myElement);
  mc.on("swipeleft", function(ev) {
    if($('html').hasClass('show-nav')) {
     $('button.menu-toggle').click();
    }
  });
  

  $('body').on('click', '.mobile-menu-dark-bg', function(e){
    if($('html').hasClass('show-nav')) {
        $('button.menu-toggle').click();
      }
  })
  
  $('#toggleFilters').on('click', function(){
  	$('#collectionFiltersMobile').slideToggle();
  })
  
  
  if($('.template-cart')) {
    
    var cart_quantities = $('.desktop-cart-quantity');
    var mobile_cart_quantities = $('.mobile-cart-quantity');
    
    cart_quantities.each(function(){
      $('.mobile-cart-quantity[data-line="' + $(this).attr('data-line') + '"]').val($(this).val());
    })
    
    cart_quantities.on('change', function(){
      var item_quantity = $(this).val();
      var item_row = $(this).attr('data-line');
      
      var get_mobile_item_quantity = $('.mobile-cart-quantity[data-line="' + item_row + '"]');
      get_mobile_item_quantity.val(item_quantity);
    })
    
    mobile_cart_quantities.on('change', function(){
      var mobile_item_quantity = $(this).val();
      var mobile_item_row = $(this).attr('data-line');
      
      var get_item_quantity = $('.desktop-cart-quantity[data-line="' + mobile_item_row + '"]');
      get_item_quantity.val(mobile_item_quantity);
    })
  }

})


$('.my-account-dropdown-toggle').on('click', function(){
	
  if($('html').hasClass('show-nav')) {
  	$('button.menu-toggle').click();
  }
  $('.my-account-dropdown').toggleClass('d-none');
  
})

$('body').on('click', function(e){
  if(!$('.my-account-dropdown').hasClass('d-none')) {
    if(!$(e.target).parents('.my-account-dropdown-toggle-wrapper').length) {
      $('.my-account-dropdown').addClass('d-none');
    }
  }
})

$(window).load(function(){
  if($('body').hasClass('template-product')) {
    $('.product-photo-thumbs a').first().click();
    $('.product-photo-container').removeClass('visually-hidden');  
  }
})


$(document).ready(function(){
  $('.template-product').on('click', '.quantity-btn', function(e){
    e.preventDefault();
    
    var current_quantity = parseInt($('.quantity-wrapper #quantity').val());
    
    if($(this).hasClass('minus')) {
      if($('.quantity-wrapper #quantity').val() > 0) {
        $('.quantity-wrapper #quantity').val(current_quantity - 1);
      }
    }
    else {
      $('.quantity-wrapper #quantity').val(current_quantity + 1);
    }
  })
  
  $('.template-cart').on('click', '.quantity-btn', function(e){
    e.preventDefault();
    
    var itemLine = $(this).siblings('input').data('line');
    
    var itemQuantity = $('.quantity-inner-wrap').find('input[data-line="' + itemLine + '"]');

    var current_quantity = parseInt(itemQuantity.val());
    
    if($(this).hasClass('minus')) {
      if(itemQuantity.val() > 0) {
        itemQuantity.val(current_quantity - 1);
      }
    }
    else {
      itemQuantity.val(current_quantity + 1);
    }
  })
})













})(jQuery);